/**
 * Has Physical ID Guards
 *
 * Guards that check if the patient has their physical ID card with them.
 */

import type { GuardWithMetadata } from "./sms.guard";

/**
 * Has Physical ID Guard
 *
 * Checks if the patient answered "Yes" to the physical ID question.
 * This determines if they proceed to photo capture vs manual entry.
 *
 * NOTE: Guards run BEFORE actions, so we check event.data (not context)
 */
export const hasPhysicalId: GuardWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState guard params are complex
  impl: ({ context, event }: { context: any; event: any }) => {
    // Check event.data first (guards run before actions)
    if (event.data && typeof event.data.hasPhysicalId === "boolean") {
      return event.data.hasPhysicalId === true;
    }

    // Fallback to context (for state restoration)
    return context.hasPhysicalId === true;
  },
  metadata: {
    displayName: "hasPhysicalId",
    description: "Patient answered YES to having physical ID",
    requiresContext: ["hasPhysicalId"],
    category: "context",
  },
};
